export default __webpack_public_path__ + "static/media/Swap-logos_transparent.75314fc6.png";